import React from "react";
import InputField from "../../Forms/Input/InputField";
import { ProductFormValues } from "../../../types/product/ProductFormValues";
import { useProduct } from "../../../hooks/useProduct";

interface Props {
  form: ProductFormValues;
  onChange: (field: keyof ProductFormValues, value: any) => void;
}

const ProductDimensionsSection: React.FC<Props> = ({ form, onChange }) => {
  const { formErrors } = useProduct();

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <InputField
        label="Peso (kg)"
        name="weight"
        type="number"
        iconKey="scale"
        placeholder="Ej: 0.75"
        value={form.weight ?? ""}
        min={0}
        onChange={(e) => onChange("weight", parseFloat(e.target.value))}
        error={formErrors.weight}
      />

      <InputField
        label="Alto (cm)"
        name="height"
        type="number"
        iconKey="ruler"
        placeholder="Ej: 15"
        value={form.height ?? ""}
        min={0}
        onChange={(e) => onChange("height", parseFloat(e.target.value))}
        error={formErrors.height}
      />

      <InputField
        label="Ancho (cm)"
        name="width"
        type="number"
        iconKey="ruler"
        placeholder="Ej: 20"
        value={form.width ?? ""}
        min={0}
        onChange={(e) => onChange("width", parseFloat(e.target.value))}
        error={formErrors.width}
      />

      <InputField
        label="Largo (cm)"
        name="length"
        type="number"
        iconKey="ruler"
        placeholder="Ej: 30"
        value={form.length ?? ""}
        min={0}
        onChange={(e) => onChange("length", parseFloat(e.target.value))}
        error={formErrors.length}
      />
    </div>
  );
};

export default ProductDimensionsSection;
